// resources/js/woocommerce/mini-cart/cross-sells-add-all.js
import { els, xs } from './dom.js';
import { openPanel } from './panel.js';

export function initCrossSellsAddAll() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(xs.addAllSel);
    if (!btn) return;

    const fieldset = btn.closest('.wk-mini-xs');
    if (!fieldset) return;

    const checks = Array.from(fieldset.querySelectorAll(`${xs.checkSel}:checked`));
    const ids = checks.map(i => i.value).filter(Boolean);
    if (!ids.length) return;

    const nonce = (fieldset.querySelector('input[name="wk_xs_nonce"]') || {}).value || '';
    const endpoint = btn.dataset.endpoint || (window.ajaxurl || '/wp-admin/admin-ajax.php');

    btn.disabled = true;

    // Optimistisch verwijderen
    checks.forEach(chk => chk.closest(xs.itemSel)?.remove());
    const container = document.getElementById(xs.containerId);
    if (container && !container.querySelector(xs.checkSel)) container.remove();

    try {
      const body = new URLSearchParams();
      body.set('action', 'wk_add_selected_to_cart');
      body.set('wk_xs_nonce', nonce);
      ids.forEach(id => body.append('ids[]', id));

      const res  = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString()
      });
      const json = await res.json();

      if (window.jQuery) jQuery(document.body).trigger('wc_fragment_refresh');

      // open mini-cart
      openPanel();

      const msg = els.message();
      if (msg) {
        msg.textContent = (json && json.success)
          ? (json.message || 'Toegevoegd aan winkelwagen.')
          : (json?.data?.message || 'Er ging iets mis.');
        msg.hidden = false;
        setTimeout(() => (msg.hidden = true), 2200);
      }
    } catch (err) {
      console.error(err);
    } finally {
      btn.disabled = false;
    }
  });
}
